<template>
    <div class="content">
        <SswgModal :visible.sync="modalVisible" :modalTitle="modalTitle" class="sswg-modal" :openFooter="openFooter" @sure="sure">
            <div class="modal-content" style="border: none;">
                <div class="vv">
                    <span class="title">开关设置</span>
                    <div class="box">
                        <el-row :gutter="24" v-if="currMarkType==2">
                            <el-col :span="12" style="height: 40px;">
                                <el-checkbox v-model="crossLineEnabled">过线告警</el-checkbox>
                            </el-col>
                        </el-row>
                        <el-row :gutter="24" v-if="currMarkType==3">
                            <el-col :span="12">
                                <el-checkbox v-model="enterAreaEnabled">船舶驶入区域告警</el-checkbox>
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox v-model="outOfAreaEnabled">船舶驶出区域告警</el-checkbox>
                            </el-col>
                        </el-row>
                        <el-row :gutter="24" v-if="currMarkType==3">
                            <el-col :span="12">
                                <el-checkbox v-model="lowSpeedEnabled">船舶最低限速告警</el-checkbox>
                                <el-input v-model="limetedLowSpeed" style="width: 50px; margin-left: 10px;"></el-input>
                                <span>Kn</span>
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox v-model="overSpeedEnabled">船舶最高限速告警</el-checkbox>
                                <el-input v-model="limetedOverSpeed" style="width: 50px; margin-left: 10px;"></el-input>
                                <span>Kn</span>
                            </el-col>
                        </el-row>
                    </div>    
                </div>
                <div class="vv" style="margin-top: 10px;">
                    <span class="title">船舶设置</span>
                    <div class="box">
                        <div class="ship">
                            <ul class="table-title" style="cursor: default;">
                                <li class="c1">序号</li>
                                <li class="c2">天线设备ID</li>
                                <li class="c3">船舶名称</li>
                                <li class="c4">加入区域</li>
                            </ul>
                            <ul v-for="(item, i) in shipList" :key="i">
                                <li class="c1">{{ i+1 }}</li>
                                <li class="c2">{{ item.positionDeviceId }}</li>
                                <li class="c3">{{ item.name }}</li>
                                <li class="c4">
                                    <input type="checkbox" class="sswg-checkbox" v-model="item.checked"></input>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </SswgModal>
    </div>
</template>

<script>

export default {
    inject: ['parent'],
    data() {
        return {
            currOperate: '', // 当前操作 add edit del

            currMarkId: 0,          // 当前标注id
            currMarkType: 0,        // 当前标注类型 1:点 2:线 3:面
            
            modalVisible: false,
            modalTitle: '区域设置',
            openFooter: true,

            crossLineEnabled: false, // 线
            enterAreaEnabled: false,
            outOfAreaEnabled: false,
            lowSpeedEnabled: false,
            overSpeedEnabled: false,

            limetedLowSpeed: '',
            limetedOverSpeed: '',

            shipList: [],
            outletsIdList: [],
            currWarnCategoryId: 0

        }
    },

    methods: {

        // 查询标注告警类目
        queryWarnCategoryByMarkId(){
            this.sswgGet('/warnCategory/fetchWarnCategoryByMarkId/'+this.currMarkId, {}, true, 'json').then(res => {
                if(res && res.code==200){
                    let d = res.data
                    this.crossLineEnabled = d.crossLineEnabled
                    this.enterAreaEnabled = d.enterAreaEnabled
                    this.outOfAreaEnabled = d.outOfAreaEnabled
                    this.lowSpeedEnabled = d.lowSpeedEnabled
                    this.overSpeedEnabled = d.overSpeedEnabled
                    this.limetedLowSpeed = d.limetedLowSpeed?d.limetedLowSpeed:''
                    this.limetedOverSpeed = d.limetedOverSpeed?d.limetedOverSpeed:''
                    if(d.outletsIdList){
                        this.outletsIdList = d.outletsIdList
                        this.checkShipListChecked()
                    }
                    if(d.id){
                        this.currWarnCategoryId = d.id
                    }
                }
            })
        },

        // 检查填充选中
        checkShipListChecked(){
            for(let i=0; i<this.shipList.length; i++){
                if(this.outletsIdList.includes(this.shipList[i].id)){
                    this.shipList[i].checked = true
                }else{
                    this.shipList[i].checked = false
                }
            }
        },

        // 重置
        resetData(){
            this.crossLineEnabled = false // 线
            this.enterAreaEnabled = false
            this.outOfAreaEnabled = false
            this.lowSpeedEnabled = false
            this.overSpeedEnabled = false
            this.outletsIdList = []
            this.limetedLowSpeed = ''
            this.limetedOverSpeed = ''
            this.shipList = []
            this.currWarnCategoryId = 0
        },

        /**
         * 设置当前操作
         * @param oper setting 
         * @param mark 线 面
         */
        setCurrOperate(oper, mark){
            this.resetData()
            if(oper=='setting'){
                this.currMarkId = mark.id
                this.currMarkType = mark.markType
                // 共用船舶信息
                let shipList = this.parent.app.shipList
                for(let i=0; i<shipList.length; i++){
                    shipList[i].checked = false
                }
                this.shipList = shipList
                this.queryWarnCategoryByMarkId()
            }
        },

        // 确认
        sure(){
            let p = {}
            p.crossLineEnabled=this.crossLineEnabled // 越线
            p.enterAreaEnabled=this.enterAreaEnabled
            p.outOfAreaEnabled=this.outOfAreaEnabled
            p.lowSpeedEnabled=this.lowSpeedEnabled
            p.overSpeedEnabled=this.overSpeedEnabled
            if(this.lowSpeedEnabled && (this.limetedLowSpeed=='' || isNaN(this.limetedLowSpeed))){
                this.$message.warning('请正确填写最低限速值')
                return
            }
            if(this.overSpeedEnabled && (this.limetedOverSpeed=='' || isNaN(this.limetedOverSpeed))){
                this.$message.warning('请正确填写最高限速值')
                return
            }
            if(this.lowSpeedEnabled && this.overSpeedEnabled && parseFloat(this.limetedOverSpeed)<parseFloat(this.limetedLowSpeed)){
                this.$message.warning('最高限速值需要大于最小限速值')
                return
            }

            if(this.lowSpeedEnabled && !isNaN(this.limetedLowSpeed)){
                p.limetedLowSpeed=this.limetedLowSpeed
            }else{
                p.limetedLowSpeed=''
            }
            if(this.overSpeedEnabled && !isNaN(this.limetedOverSpeed)){
                p.limetedOverSpeed=this.limetedOverSpeed
            }else{
                p.limetedOverSpeed=''
            }
            let ids = []
            for(let i=0; i<this.shipList.length; i++){
                if(this.shipList[i].checked){
                    ids.push(this.shipList[i].id)
                }
            }
            p.outletsIdList=ids
            p.crossLineEnabled=this.crossLineEnabled // 越线
            p.enterAreaEnabled=this.enterAreaEnabled
            p.outOfAreaEnabled=this.outOfAreaEnabled
            p.lowSpeedEnabled=this.lowSpeedEnabled
            p.overSpeedEnabled=this.overSpeedEnabled
            // 勾选了船，则要勾选开关 
            if(ids.length>0 && !p.crossLineEnabled && !p.enterAreaEnabled && !p.outOfAreaEnabled && !p.lowSpeedEnabled && !p.overSpeedEnabled){
                this.$message.warning('请勾选开关设置')
                return
            }
            // 可以不勾选船舶，表示取消加入区域 (后台逻辑有点问题,无作用)
            // if(ids.length==0 && this.currWarnCategoryId!=0){
            //     p.id = this.currWarnCategoryId
            // }
            p.serviceId = this.currMarkId
            p.serviceType = 1 // 1:标注 2:航线
            console.log(p)
            // return 
            this.sswgPost('/warnCategory/saveOrUpdateWarnCategory', p, true, 'json').then(res => {
                this.close()
                this.parent.app.queryShipWarnCategoryList()
            })
        },

        close(){
            this.currOperate = ''
            this.currMarkId = 0
            this.modalVisible = false
        },

        setShow(){
            this.modalVisible = true
        }
    }

}

</script>

<style lang="scss" scoped>
    .content {
        .modal-content {
            width: 500px;
            padding: 10px;
            border: 1px solid #FFFFFF;
            border-radius: 0;
            .vv {
                .title {
                    font-size: 12px;
                }
                .box {
                    margin-top: 5px;
                    border: 1px solid #a0bed5;
                    border-radius: 5px;
                    padding: 10px;
                    .ship {
                        background-color: #FFFFFF;
                        min-height: 220px;
                        max-height: 320px;
                        overflow-y: auto;
                        ul {
                            display: flex;
                            text-align: center;
                            line-height: 22px;
                            font-size: 12px;
                            color: #000;
                            border-bottom: 1px dashed rgb(180, 179, 179);
                            .c1 {
                                width: 70px;
                            }
                            .c2 {
                                width: 130px;
                            }
                            .c3 {
                                width: 180px;
                            }
                            .c4 {
                                width: 80px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            }
                        }
                        ul:hover {
                            background-color: #86e9f9;
                        }
                        .table-title {
                            color: #FFF;
                            font-size: 12px;
                            line-height: 20px;
                            user-select: none;
                            background-color: #0393ed;
                        }
                        .table-title:hover{
                            background-color: #0393ed;
                        }
                    }
                }
            }
        }
    }
</style>

<style scoped>
    .modal-content >>> input.el-input__inner {
        font-size: 15px;
        font-weight: bold;
        height: 26px;
        line-height: 26px;
        background: none;
        color: #FFFFFF;
        padding: 0 5px;
    }
    .modal-content >>> .el-checkbox__label {
        color: #ffffff;
    }

    .modal-content >>> .el-checkbox__input.is-checked+.el-checkbox__label {
        color: #FFFFFF;
    }
    
</style>

